import escape from 'escape-html';

const evaluateFilterEquation = (filters: string) => {
  let queryFilters = filters;

  const operand = ['+', '-'];

  operand.forEach(op => {
    let position = 0;
    let opIndex = queryFilters.indexOf(op, position);

    while (opIndex > -1) {
      const left = queryFilters.substring(0, opIndex);
      const right = queryFilters.substring(opIndex + 1);
      const leftNum = left.trim().split(' ').reverse()[0];
      const rightNum = right.trim().split(' ')[0];

      if (!isNaN(+leftNum) && !isNaN(+rightNum)) {
        const leftTrim = left.substring(left.length - 1) === ' ' ? ' ' : '';
        const rightTrim = right.substring(0, 1) === ' ' ? ' ' : '';
        let expr;

        switch (op) {
          case '+':
            expr = parseFloat(leftNum) + parseFloat(rightNum);
            break;
          case '-':
            expr = parseFloat(leftNum) - parseFloat(rightNum);
            break;
        }

        queryFilters = queryFilters.replace(leftNum + leftTrim + op + rightTrim + rightNum, expr);
        position = opIndex + 1;
        opIndex = queryFilters.indexOf(op, position);
      }
    }
  });

  return queryFilters;
};

type BuildSearchFiltersOptions = {
  shouldExcludeMarketplaceProducts?: boolean;
};

const BASE_ALGOLIA_QUERY_FILTERS = '(price > 0 AND product_published = 1 AND availability.displayProduct = 1)';
const BASE_ALGOLIA_QUERY_FILTERS_EXCLUDE_MARKETPLACE =
  '(price > 0 AND product_published = 1 AND availability.displayProduct = 1 AND isMarketplace = 0)';

export const buildSearchFilters = (filters?: string, options?: BuildSearchFiltersOptions) => {
  const baseFilters = options?.shouldExcludeMarketplaceProducts
    ? BASE_ALGOLIA_QUERY_FILTERS_EXCLUDE_MARKETPLACE
    : BASE_ALGOLIA_QUERY_FILTERS;
  if (!filters) {
    return baseFilters;
  }

  let queryFilters = filters;

  if (queryFilters.indexOf('${now}') > 0) {
    const now = Math.floor(Date.now() / 1000);
    queryFilters = queryFilters.replace(/\${now}/g, `${now}`);
    queryFilters = evaluateFilterEquation(queryFilters);
  }
  return `${queryFilters} AND ${baseFilters}`;
};

export const buildSearchContentFilters = (searchTerm: string) => {
  if (!searchTerm) {
    return '';
  }

  return `"keywords":"${escape(searchTerm)}"`;
};
